export const TRANS = {
  figure: { en: 'Figure', fi: 'Kuvio' },
};
